import React, { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useSelector } from "react-redux";
import { getIsMobile } from "features/app/UIRelatedSlice";
import { NavLink } from "react-router-dom";
import { setShowSubscribeWindow } from "features/states/statesSlice";
import { useDispatch } from "react-redux";

export default function ImgWhiteTemplate(props: any) {
  const [ref, inView] = useInView({
    triggerOnce: props.triggerOnce,
    rootMargin: props.rootMargin || "0% 0px",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [mediaLoaded, setMediaLoaded] = useState(false);
  const isMobile = useSelector(getIsMobile);

  useEffect(() => {
    if (videoRef.current) {
      const videoElement = videoRef.current;
      videoElement.playbackRate = 0.33;
    }
  }, [videoRef]);

  useEffect(() => {
    if (isMobile && videoRef.current) {
      const videoElement = videoRef.current;
      videoElement.muted = true;
      videoElement.playsInline = true;
      videoElement.play();
    }
  }, [isMobile, videoRef]);

  useEffect(() => {
    if (videoRef.current) {
      const videoElement = videoRef.current;
      const handleVideoLoad = () => {
        setMediaLoaded(true);
        videoElement.muted = true;
        videoElement.playsInline = true;
        videoElement.play();
        videoElement.playbackRate = 0.33; // Ensure playback rate is set to 0.33
        console.log("video loaded");
      };

      videoElement.addEventListener("canplaythrough", handleVideoLoad);

      return () => {
        videoElement.removeEventListener("canplaythrough", handleVideoLoad);
      };
    }
  }, [videoRef]);

  return (
    <div className="relative z-0 w-full h-[500px] p-10">
      {props.backgroundImg.type === "img" && (
        <img
          className="w-full h-full object-cover"
          src={props.backgroundImg.src}
          alt={`${props.backgroundImg.alt}`}
        />
      )}
      {props.backgroundImg.type === "video" && (
        <video
          className={`w-full h-full object-cover ${
            props.backgroundImg.objectPosition
              ? props.backgroundImg.objectPosition
              : "object-bottom"
          }`}
          src={props.backgroundImg.src}
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          controlsList="nodownload noremoteplayback noplaybackrate"
        />
      )}
      {props.backgroundImg.type === "text" && (
        <div
          className={` relative w-full h-full bg-${props.backgroundImg.color}`}
        >
          <p className="absolute bottom-10 right-10 text-white/50 text-5xl font-thin font-body">
            {props.backgroundImg.content}
          </p>
        </div>
      )}
      <div className="absolute inset-0 p-10">
        <div className="m-12 min-h-[200px] max-w-[550px] shadow-lg bg-white flex">
          <div className="border-l-4 border-main m-10 pl-6 py-2">
            <h1 className="text-4xl font-headings">{props.h1}</h1>
            <p className="text-lg mt-4">{props.description}</p>
            {props.btn && (
              <button
                className="bg-main text-base uppercase hover:bg-main-darker text-white px-4 py-1 font-body mt-8"
                type="button"
                onClick={() => {
                  dispatch(setShowSubscribeWindow(true));
                }}
              >
                Subscribe
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
